import {
    appBarHeightMobile,
    isGlobalDrawerOpenAtom,
} from '@/components/GlobalNavigationDrawer/lib/constants';
import { useReserveRootNavOffset } from '@/components/layout/rootNavOffset';
import { useBooleanStateAtom } from '@/utils/booleanState';
import { ReturnComponent } from '@/utils/reactTypes';
import { SwipeableDrawer } from '@mui/material';

import { GlobalDrawerItems } from './GlobalDrawerItems';
import { GlobalMobileAppBar } from './GlobalMobileAppBar';

export const GlobalMobileNavigationDrawer = (): ReturnComponent => {
    const [isDrawerOpen, openDrawer, closeDrawer] = useBooleanStateAtom(isGlobalDrawerOpenAtom);

    // Offset the app root (#root) below the fixed app bar instead of wrapping content in a
    // box, keeping native scroll restoration (body stays the scroll container). The temporary
    // drawer overlays, so it reserves no horizontal space.
    useReserveRootNavOffset({ paddingTop: appBarHeightMobile });

    return (
        <>
            <GlobalMobileAppBar />
            <SwipeableDrawer
                anchor={'left'}
                open={isDrawerOpen}
                onOpen={openDrawer}
                onClose={closeDrawer}
            >
                <GlobalDrawerItems />
            </SwipeableDrawer>
        </>
    );
};
